import { observable } from 'mobx'

/**
 * Author: Hanamantraya R
 * Class Name: ObjRssFeeds
 * Description: Observation Class to create object of class for RSS feeds.
 */
export default class {
  id = null;
  @observable rss_feed_name = null;
  @observable rss_feed_link = null;
  @observable is_active = null;
  @observable page_name = null;

  /**
   * @Author: Hanamantraya R
   * @Method: constructor
   * @Param: Object(params)
   * @Return: Void
   * Description: Nothing return
   */
  constructor (json) {
    this.id = json.id
    this.rss_feed_name = json.rss_feed_name
    this.rss_feed_link = json.rss_feed_link
    this.is_active = json.is_active
    this.page_name = json.page_name
  }

  /**
   * @Author: Hanamantraya R
   * @Method: jsonToArray
   * @Param: Object(json)
   * @Return: Array
   * Description: Return array of objects
   */
  static jsonToArray (json) {
    return json.reduce((acc, curr) => {
      acc[curr.id] = new this(curr)
      return acc
    }, {})
  }

  /**
   * @Author: Hanamantraya R
   * @Method: constructFromJSON
   * @Param: Object(json)
   * @Return: Object
   * Description: Return  objects
   */
  static constructFromJSON (json) {
    return new this(json)
  }

  /**
   * @Author: Hanamantraya R
   * @Method: constructFromJSON
   * @Param: Object(entries)
   * @Return: Object
   * Description: Update the details of particular record
   */
  update (entries) {
    for (const key in entries) {
      this[key] = entries[key]
    }
  }
}
